import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box, Typography } from "@mui/material";
import Styles from "../../Reusable/Forms/FormSteps/FinalStatus.module.css";

interface Content {
  suppliers: string;
  outputs: string;
  inputs: string;
  id: number;
  created_at: string;
  updated_at: string;
  updated_by?: string;
  created_by?: string;
  status: string;
  bd_stage?: string;
  clients: string;
  is_existing_bd?: boolean;
    doc_path?: string;
  file_name?: string;
  file_size?: string;
  management?: string;
  function_l1?: string;
  function_l2?: string;
  manager_id?: string;
  approved_by?: string;
  reason_to_approve?: string;
}


interface DeleteConfirmationDialogProps {
  open: boolean;
  handleClose: () => void;
  handleDelete?: (id: number) => void;
  row?: Content;
  loading?: boolean;


}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  handleClose,
  handleDelete,
  loading,
  row
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box sx={{ maxWidth: "500px" }}>
        <DialogTitle sx={{ textAlign: "center" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <path d="M6 12H10H42" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M38 12V40C38 41.0609 37.5786 42.0783 36.8284 42.8284C36.0783 43.5786 35.0609 44 34 44H14C12.9391 44 11.9217 43.5786 11.1716 42.8284C10.4214 42.0783 10 41.0609 10 40V12M16 12V8C16 6.93913 16.4214 5.92172 17.1716 5.17157C17.9217 4.42143 18.9391 4 20 4H28C29.0609 4 30.0783 4.42143 30.8284 5.17157C31.5786 5.92172 32 6.93913 32 8V12" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M20 22V34" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M28 22V34" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          <Typography className={Styles.titlemodal}>Confirm Deletion</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={Styles.deletedialogcontent}>
            Are you sure you want to delete this file? This action cannot be undone.
            Deleting this file will also remove its entire history from the database, and it cannot be recovered.
          </DialogContentText>
        </DialogContent>
        <DialogActions className={Styles.actionbtns}>
          <Button className={Styles.deletebtn} onClick={() => handleDelete && row && handleDelete(row.id)} autoFocus disabled={loading}>
            {loading ? "Deleting..." : "Delete"}
          </Button>
          <Button className={Styles.cancelbtn} onClick={handleClose} autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;